var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 20 20",
    fill: "#7C7C7C",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/export"
  }, /*#__PURE__*/React.createElement("g", {
    id: "export"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0415039 9.00008C0.0415039 4.0549 4.05466 0.041748 8.99984 0.041748C9.34502 0.041748 9.62484 0.32157 9.62484 0.666748C9.62484 1.01193 9.34502 1.29175 8.99984 1.29175C4.74502 1.29175 1.2915 4.74526 1.2915 9.00008C1.2915 13.2549 4.74502 16.7084 8.99984 16.7084C13.2547 16.7084 16.7082 13.2549 16.7082 9.00008C16.7082 8.6549 16.988 8.37508 17.3332 8.37508C17.6783 8.37508 17.9582 8.6549 17.9582 9.00008C17.9582 13.9453 13.945 17.9584 8.99984 17.9584C4.05466 17.9584 0.0415039 13.9453 0.0415039 9.00008Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1083 0.891554C17.3524 1.13563 17.3524 1.53136 17.1083 1.77544L10.2749 8.60877C10.0309 8.85285 9.63514 8.85285 9.39107 8.60877C9.14699 8.36469 9.14699 7.96896 9.39107 7.72489L16.2244 0.891554C16.4685 0.647477 16.8642 0.647477 17.1083 0.891554Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6831 0.666748C12.6831 0.32157 12.9629 0.041748 13.3081 0.041748H17.3331C17.6783 0.041748 17.9581 0.32157 17.9581 0.666748V4.69175C17.9581 5.03693 17.6783 5.31675 17.3331 5.31675C16.9879 5.31675 16.7081 5.03693 16.7081 4.69175V1.29175H13.3081C12.9629 1.29175 12.6831 1.01193 12.6831 0.666748Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.44f0ef5a052abf612756274ba570b117.svg";
export { ForwardRef as ReactComponent };